export type UploadStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "FAILED";

export class UploadHistory {
  constructor(
    public readonly id: string,
    public readonly filePath: string,
    public readonly status: UploadStatus,
    public readonly createdAt: Date,
    public readonly failedReason?: string,
    public readonly completedAt?: Date,
  ) {}

  get fileName(): string {
    return this.filePath.split("/").pop() ?? "";
  }

  get isCompleted(): boolean {
    return this.status === "COMPLETED";
  }
}
